import { useEffect, useState, useMemo } from "react";

import { useLocation, Link } from "react-router-dom";

import PropTypes from "prop-types";

import ArgonBox from "component/Argon/ArgonBox";

import { useArgonController, setLayout, setMiniSidenav } from "context";
import Sidenav from "component/Sidenav";

import Fab from '@mui/material/Fab';
import ShoppingCart from '@mui/icons-material/ShoppingCart';

// Images
// import brand from 'assets/images/logo-ct.png';
// import brandDark from 'assets/images/logo-ct-dark.png';

// trk_logo.jpeg
import brand from 'assets/images/trk_logo.png';
import brandDark from 'assets/images/trk_logo.png';

// import routes from 'routes/routes';
import sidenav from 'routes/sidenav';
import sidenav_admin from 'routes/sidenav-admin';
import sidenav_end from 'routes/sidenav-end';

import useAuth from "auth/hook/useAuth";
import ROLES from "auth/roles";

function DashboardLayout({ bgColor, children, ...rest }) {
  const { auth } = useAuth();
  const [controller, dispatch] = useArgonController();
  const { pathname } = useLocation();
  const { miniSidenav, layout, sidenavColor, darkSidenav, darkMode } =
    controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  useEffect(() => {
    setLayout(dispatch, "dashboard");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const sideNavMenu = useMemo(() => {
    if (auth?.roles) {
      if (auth?.roles?.includes(ROLES.Admin)) {
        return sidenav.concat(sidenav_admin).concat(sidenav_end);
      }
    }
    return sidenav.concat(sidenav_end);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.accessToken]);

  const background = darkMode && !bgColor ? "transparent" : bgColor;

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  return (
    <ArgonBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      <ArgonBox
        bgColor={background || "info"}
        height="300px"
        width="100vw"
        position="absolute"
        top={0}
        left={0}
        sx={darkMode && { bgColor: ({ palette: { background } }) => background.default }}
        {...rest}
      />
      {layout === 'dashboard' && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={darkSidenav || darkMode ? brand : brandDark}
            brandName="TKR Broker"
            routes={sideNavMenu}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
        </>
      )}
      {children}
      <ArgonBox
        position="fixed"
        bottom='1rem'
        right='2rem'
        zIndex={99}
      >
        <Fab color="white" aria-label="shoppingCart" component={Link} to='/cart' >
          <ShoppingCart />
        </Fab>
      </ArgonBox>
    </ArgonBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
